import * as React from "react";
import ReactDOM from "react-dom";
import { Example, type ExampleType } from "./Example";

type ExampleTypes = Record<string, ExampleType>;

type Props = {
    section: string;
    language: string;
    examples: Array<ExampleTypes>;
};

type State = {
    sectionNode: null | Element;
    height: number;
};

export default class ExampleBlock extends React.Component<Props, State> {
    public state: State = {
        sectionNode: null,
        height     : 0,
    };

    public componentDidMount(): void {
        const node = document.querySelector(`#${this.props.section}-example`);

        const bounding = node?.getBoundingClientRect();
        const height = bounding?.height || 0;

        this.setState({
            sectionNode: node,
            height     : Math.max(150, height),
        });
    }

    public render(): React.ReactNode {
        if(!this.state.sectionNode) {
            return null;
        }

        return ReactDOM.createPortal(
            this.props.examples.map((example, index) => {
                for(const i in example) {
                    if(!Object.prototype.hasOwnProperty.call(example, i)) {
                        continue;
                    }

                    if(i === this.props.language) {
                        return (
                            <Example
                                key={index}
                                height={this.state.height}
                                {...example[i]}
                            />
                        );
                    }
                }

                return null;
            }),
            this.state.sectionNode
        );
    }
}
